import { render, staticRenderFns } from "./ParkEventsTable.vue?vue&type=template&id=22fbf282"
import script from "./ParkEventsTable.vue?vue&type=script&lang=ts"
export * from "./ParkEventsTable.vue?vue&type=script&lang=ts"
import style0 from "./ParkEventsTable.vue?vue&type=style&index=0&id=22fbf282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports